import "./OnlineApp.module.css";
import NavigationBar from "@/reusable_sections/Header";
import Authentication from "./sections/Authentication";
import WaaromKoopmeester from "./sections/WaaromKoopmeester";
import FooterInformation from "@/reusable_sections/Footer";
export default function OnlineAppPage() {
  return <div>
      <NavigationBar />
      <Authentication />
      <WaaromKoopmeester />
      <FooterInformation />
    </div>;
}